import './style/HeaderComponent.css';
import React, { useRef, useState, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Offcanvas } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap'
import { Ellipsis } from 'react-bootstrap/esm/PageItem';
import { toBeEnabled } from '@testing-library/jest-dom/matchers';
import { ForeGroundContext } from './ForeGroundContext';
import icon2 from './image/colorixlogofull.png'; 
import icon8 from './image/colorix_depliant_1.jpg';
import icon9 from './image/colorix_bouquin_graike.jpg';
import icon10 from './image/colorix_shopping_bag.jpg';
import icon11 from './image/colorix_depliant_2.jpg';
import icon12 from './image/colorix_brochures2.jpg';
import axios from 'axios';
import { useLanguage } from './LanguageContext';


  

function HeaderComponent({ isMenuVisible, isScrollEnabled, setIsScrollEnabled }) {

  const { language, setLanguage } = useLanguage();  // Get current language and setter
  const [Navbarcat, setNavbarcat] = useState([]); 
  const [text, settext] = useState(null);

  useEffect(() => {
    const browserLanguage = navigator.language || navigator.userLanguage;
    if (browserLanguage.includes('fr')) {
      setLanguage('FR'); // If browser language is English, set to English
    } else {
      setLanguage('EN'); // Default to French
    }
  }, [setLanguage]); // Run only once when the component mounts



  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };

  useEffect(() => {
  if (language === 'FR') {
    const cachednavbarbardatenfr = JSON.parse(localStorage.getItem('navbarbardatenfr'));
    if (cachednavbarbardatenfr) {
      // If images are found in localStorage, use them
      setNavbarcat(cachednavbarbardatenfr);
      const text = 'Satisfait ou Re-imprime : +237 691 86 82 82 / 696 26 26 56';
      settext(text);
      
    } else {

      axios.get('https://colorixbackend.seuytel.com/navbarfr')
        .then(response => {
          const categorynavItems = response.data.filter(item => item.page_group === 'Category');
          setNavbarcat(categorynavItems);
          localStorage.setItem('navbarbardatenfr', JSON.stringify(categorynavItems));
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });

        const text = 'Satisfait ou Re-imprime : +237 691 86 82 82 / 696 26 26 56';
        settext(text);
      } 
    } else {
      const cachednavbarbardatenen = JSON.parse(localStorage.getItem('navbarbardatenen'));
      if (cachednavbarbardatenen) {
        // If images are found in localStorage, use them
        setNavbarcat(cachednavbarbardatenen);
        const text = 'Satisfied or Reprinted: +237 691 86 82 82 / 696 26 26 56';
        settext(text);
      } else {
    
        axios.get('https://colorixbackend.seuytel.com/navbaren')
          .then(response => {
            const categorynavItems = response.data.filter(item => item.page_group === 'Category');
            setNavbarcat(categorynavItems);
            localStorage.setItem('navbarbardatenen', JSON.stringify(categorynavItems));
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });
    
          const text = 'Satisfied or Reprinted: +237 691 86 82 82 / 696 26 26 56';
          settext(text);
        } 
    }
  }, [language]);

  const navbarcat0 = Navbarcat[0]?.value ? Object.values(JSON.parse(Navbarcat[0].value)) : [];
  const navbarcat1 = Navbarcat[1]?.value ? Object.values(JSON.parse(Navbarcat[1].value)) : [];
  const navbarcat2 = Navbarcat[2]?.value ? Object.values(JSON.parse(Navbarcat[2].value)) : [];
  const navbarcat3 = Navbarcat[3]?.value ? Object.values(JSON.parse(Navbarcat[3].value)) : [];
  const navbarcat4 = Navbarcat[4]?.value ? Object.values(JSON.parse(Navbarcat[4].value)) : [];

 // const [isMenuVisible, setIsMenuVisible] = useState(true); // Controls menu visibility
  // const [prevMenuScrollPos, setPrevMenuScrollPos] = useState(0); // Tracks the last scroll position

  {/* stop scoll effect on hover menu*/}
  const stopscrolleffect = () => {
    // Toggle scrollEnabled when this button is clicked
    setIsScrollEnabled(false);
  };
  const enabledpscrolleffect = () => {
    // Toggle scrollEnabled when this button is clicked
    setIsScrollEnabled(true);
  };
  
  const inputRef = useRef();

  const handleButtonClick = () => {
    inputRef.current.click(); // Simulates a click on the input
  };
  
  const [show, setShow] = useState(false);
  const impressionElementRef = useRef(null);
  const restaurantAndHotelElementRef = useRef(null);
  const eventElementRef = useRef(null);
  const gadjetElementRef = useRef(null);
  const yourColorixElementRef = useRef(null);
  const [impressionClick, setImpressionClick] = useState(false);
  const [smallImpressionClick, setSmallImpressionClick] = useState(false);
  const [restaurantAndHotelClick, setRestaurantAndHotelClick] = useState(false);
  const [smallRestaurantAndHotelClick, setSmallRestaurantAndHotelClick] = useState(false);
  const [eventClick, setEventClick] = useState(false);
  const [smallEventClick, setSmallEventClick] = useState(false);
  const [gadjetClick, setGadjetClick] = useState(false);
  const [smallGadjetClick, setSmallGadjetClick] = useState(false);
  const [yourColorixClick, setYourColorixClick] = useState(false);
  const [smallYourColorixClick, setSmallYourColorixClick] = useState(false);


  {/** pass the foregound to the other children */}
  const { setIsForeGround } = useContext(ForeGroundContext);
  /**navigationn impression btn */
  const isImpressionClick = () => {
    if(impressionClick) {
      setImpressionClick(false);
    } else {
      setImpressionClick(true);
    }
  }
  const isSmallImpressionClick = () => {
    setSmallRestaurantAndHotelClick(false);
    setSmallEventClick(false);
    setSmallGadjetClick(false);
    if(smallImpressionClick) {
      setSmallImpressionClick(false);
    } else {
      setSmallImpressionClick(true);
    }
  }
  const handleImpressionMouseEnter = () => {
    setImpressionClick(true);
    setIsForeGround(true);
    /**if (impressionElementRef.current) {
      impressionElementRef.current.classlist.add("nav-list-hover");
    }*/
  };
  const handleImpressionMouseLeave = () => {
    setImpressionClick(false); // Set state to false when not hovered
    setIsForeGround(false);
    /**if (impressionElementRef.current) {
      impressionElementRef.current.classList.remove("nav-list-hover");
    }*/
  };

  /**navigationn restaurantAndHotel btn */
  const isRestaurantAndHotelClick = () => {
    if(restaurantAndHotelClick) {
      setRestaurantAndHotelClick(false);
    } else {
      setRestaurantAndHotelClick(true);
    }
  }
  const isSmallRestaurantAndHotelClick = () => {
    setSmallImpressionClick(false);
    setSmallEventClick(false);
    setSmallGadjetClick(false);
    if(smallRestaurantAndHotelClick) {
      setSmallRestaurantAndHotelClick(false);
    } else {
      setSmallRestaurantAndHotelClick(true);
    }
  }
  const handleRestaurantAndHotelMouseEnter = () => {
    setRestaurantAndHotelClick(true);
    setIsForeGround(true);
    /**if (impressionElementRef.current) {
      impressionElementRef.current.classlist.add("nav-list-hover");
    }*/
  };
  const handleRestaurantAndHotelMouseLeave = () => {
    setRestaurantAndHotelClick(false); // Set state to false when not hovered
    setIsForeGround(false);
    /**if (impressionElementRef.current) {
      impressionElementRef.current.classList.remove("nav-list-hover");
    }*/
  };

  /**navigationn about us btn */
  const isEventClick = () => {
    if(eventClick) {
      setEventClick(false);
    } else {
      setEventClick(true);
    }
  }
  const isSmallEventClick = () => {
    setSmallImpressionClick(false);
    setSmallGadjetClick(false);
    setSmallRestaurantAndHotelClick(false);
    if(smallEventClick) {
      setSmallEventClick(false);
    } else {
      setSmallEventClick(true);
    }
  }
  const handleEventMouseEnter = () => {
    setEventClick(true);
    setIsForeGround(true);
    /**if (impressionElementRef.current) {
      impressionElementRef.current.classlist.add("nav-list-hover");
    }*/
  };
  const handleEventMouseLeave = () => {
    setEventClick(false); // Set state to false when not hovered
    setIsForeGround(false);
    /**if (impressionElementRef.current) {
      impressionElementRef.current.classList.remove("nav-list-hover");
    }*/
  };

  /**navigationn gadjet btn */
  const isgadjetClick = () => {
    if(gadjetClick) {
      setGadjetClick(false);
    } else {
      setGadjetClick(true);
    }
  }
  const isSmallGadjetClick = () => {
    setSmallEventClick(false);
    setSmallImpressionClick(false);
    setSmallRestaurantAndHotelClick(false);
    if(smallGadjetClick) {
      setSmallGadjetClick(false);
    } else {
      setSmallGadjetClick(true);
    }
  }
  const handlegadjetMouseEnter = () => {
    setGadjetClick(true);
    setIsForeGround(true);
    /**if (impressionElementRef.current) {
      impressionElementRef.current.classlist.add("nav-list-hover");
    }*/
  };
  const handlegadjetMouseLeave = () => {
    setGadjetClick(false); // Set state to false when not hovered
    setIsForeGround(false);
    /**if (impressionElementRef.current) {
      impressionElementRef.current.classList.remove("nav-list-hover");
    }*/
  };
  /**navigationn YourColorix btn */
  const isYourColorixClick = () => {
    if(yourColorixClick) {
      setYourColorixClick(false);
    } else {
      setYourColorixClick(true);
    }
  }
  const isSmallYourColorixClick = () => {
    setSmallEventClick(false);
    setSmallImpressionClick(false);
    setSmallRestaurantAndHotelClick(false);
    setSmallGadjetClick(false);
    if(smallYourColorixClick) {
      setSmallYourColorixClick(false);
    } else {
      setSmallYourColorixClick(true);
    }
  }
  const handleYourColorixMouseEnter = () => {
    setYourColorixClick(true);
    setIsForeGround(true);
    /**if (impressionElementRef.current) {
      impressionElementRef.current.classlist.add("nav-list-hover");
    }*/
  };
  const handleYourColorixMouseLeave = () => {
    setYourColorixClick(false); // Set state to false when not hovered
    setIsForeGround(false);
    /**if (impressionElementRef.current) {
      impressionElementRef.current.classList.remove("nav-list-hover");
    }*/
  };
  /**enter the menu on small screens btn */
  const menuClick = () => {
    if(show) {
      setShow(false);
      setIsForeGround(false);
      document.body.style.overflow = 'auto';
    } else {
      setShow(true);
      setIsForeGround(true);
      document.body.style.overflow = 'hidden';
    }
    setSmallImpressionClick(false);
    setSmallRestaurantAndHotelClick(false);
    setSmallEventClick(false);
    setSmallGadjetClick(false);
  };
  {/**close the menus when clicking overlay */}
  const closeMenus = () => {
    document.body.style.overflow = 'auto'; 
    setShow(false);
    setSmallImpressionClick(false);
    setSmallRestaurantAndHotelClick(false);
    setSmallEventClick(false);
    setSmallGadjetClick(false);
    setSmallYourColorixClick(false);
    setIsForeGround(false);
    setImpressionClick(false);
    setRestaurantAndHotelClick(false);
    setEventClick(false);
    setGadjetClick(false);
    setYourColorixClick(false);
  }
  const [showSearch, setShowSearch] = useState(false);

  const toggleSearch = () => {
    setShowSearch(prev => !prev);
  };


    const [isOpen, setIsOpen] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    useEffect(() => {
      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    
      // Clean up on unmount just in case
      return () => {
        document.body.style.overflow = 'auto';
      };
    }, [isOpen]);
    
    const togglePopup = () => {
      if (isOpen) {
        setIsClosing(true); // start fadeOut
        setTimeout(() => {
          setIsOpen(false);
          setIsClosing(false);
        }, 300); // match fadeOut duration
      } else {
        setIsOpen(true);
      }
    };
   

  return  (
    <div className="header-bg-color"  style={{
      position: "fixed",
      top: 0,
      width: "100%",
      zIndex: 99999999,
      display: isMenuVisible ? "block" : "none", // Toggle visibility
      animation: isMenuVisible? 'slideIn 0.5s ease forwards' : 'slideOut 0.2s ease forwards' //"all 1s ease-in-out":  // Smooth hide/show
    }}>
      <div className="container-fluid d-flex flex-column header-class" data-bs-theme="light">
        {/*first level menu*/}
        <div className='mt-1 mb-1'>
          <div className="container-xl d-flex">
            <div className="me-auto marquee" style={{textAlign:'center'}}>
              <div className="scroll-track">
                <div className="scroll-text"><p class="telgadjet" style={{color:'red'}}>{text}</p></div>
                <div className="scroll-text"><p class="telgadjet" style={{color:'red'}}>{text}</p></div>
              </div> 
            </div>
            <div className="d-flex" style={{height: '20px'}}>
              <select class="selctcustom header-bg-color me-2" style={{borderStyle: 'none', border: 'none'}}>
                <option value="Option 1" selected><p> Cameroun</p></option>
                <option value="Option 2">RCA</option>
                <option value="Option 3">RDC</option>
              </select>
              <select class="selctcustom header-bg-color" value={language} onChange={handleLanguageChange} style={{borderStyle:'none', border:'none'}}>
                <option value="FR" ><p> <b>FR</b></p></option>
                <option value="EN">EN</option>
              </select>
            </div>
          </div>
        </div>
        {/*dropdowmmenu*/}
        <div className="container-xl classt">
          <div className="me-auto d-flex-md justify-content-end">
            <a className="text-decoration-none" style={{width: "fit-content", color:"black", opacity:"80%"}} href="#">
              <img class="colorixlogo" src={icon2} alt="" />
            </a>
          </div>
          <div className='d-flex flex-direction-column me-auto' style={{width:"fit-content", height:"45px"}}>
            <div className={`p-2 ${impressionClick ? 'nav-list-hover' : ''}`} role="button" ref={impressionElementRef} onMouseEnter={() => {handleImpressionMouseEnter(); stopscrolleffect();}} onMouseLeave={() => {handleImpressionMouseLeave(); enabledpscrolleffect();}} onClick={isImpressionClick}>
              <span>{Navbarcat[0]?.page_part}</span>
            </div>
            <div className={`p-2 ${restaurantAndHotelClick ? 'nav-list-hover' : ''}`} role="button" ref={restaurantAndHotelElementRef} onMouseEnter={() => {handleRestaurantAndHotelMouseEnter(); stopscrolleffect();}} onMouseLeave={() => {handleRestaurantAndHotelMouseLeave(); enabledpscrolleffect();}} onClick={isRestaurantAndHotelClick}>
              <span>{Navbarcat[1]?.page_part}</span>
            </div>
            <div className={`p-2 ${eventClick ? 'nav-list-hover' : ''}`} role="button" ref={eventElementRef} onMouseEnter={() => {handleEventMouseEnter(); stopscrolleffect();}} onMouseLeave={() => {handleEventMouseLeave(); enabledpscrolleffect();}} onClick={isEventClick}>
              <span>{Navbarcat[2]?.page_part}</span>
            </div>
            <div className={`p-2 ${gadjetClick ? 'nav-list-hover' : ''}`} role="button" ref={gadjetElementRef} onMouseEnter={() => {handlegadjetMouseEnter(); stopscrolleffect();}} onMouseLeave={() => {handlegadjetMouseLeave(); enabledpscrolleffect();}} onClick={isgadjetClick}>
              <span>{Navbarcat[3]?.page_part}</span>
            </div>
            <div className={`p-2 ${yourColorixClick ? 'nav-list-hover' : ''}`} role="button" ref={yourColorixElementRef} onMouseEnter={() => {handleYourColorixMouseEnter(); stopscrolleffect();}} onMouseLeave={() => {handleYourColorixMouseLeave(); enabledpscrolleffect();}} onClick={isYourColorixClick}>
              <span>{Navbarcat[4]?.page_part}</span>
            </div>
          </div>
          <div className="d-flex flex-row" style={{maxWidth: "fit-content", height: "fit-content", marginTop: '4px'}}>
            <button onClick={() => setShowSearch(prev => !prev)} style={{ background: 'none', border: 'none', color: 'white', textDecoration: 'underline', cursor: 'pointer' }}> 
              <svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 -960 960 960" width="25px" fill="#fffff">
                  <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/>
              </svg>
            </button>
            <div className="mx-2 mx-xl-2 mx-xxl-3" style={{width: '2px', height: '19px', backgroundColor: 'black', marginTop: '8px' }}></div>
            <a  href="#" style={{maxWidth: "fit-content"}}>
              <svg xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 -960 960 960" width="28px" fill="#fffff">
                <path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Z"/>
              </svg>
            </a>
            <div className="mx-2 mx-xl-2 mx-xxl-3" style={{width: '2px', height: '19px', backgroundColor: 'black', marginTop: '8px' }}></div>
            <a  href="#" style={{maxWidth: "fit-content"}}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="21px">
                <path d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"/>
              </svg>
            </a>
            <div className="mx-2 mx-xl-2 mx-xxl-3" style={{width: '2px', height: '19px', backgroundColor: 'black', marginTop: '8px' }}></div>
            <a  href="#" style={{maxWidth: "fit-content"}}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="21px">
                <path d="M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"/>
              </svg>
            </a>
          </div>
        </div>
        {/*dropdowmmenu for small screens*/}
        <div className="gone-layout-xl">
          <div className="container-xl d-flex" style={{paddingBottom: '0px'}}>
            <div className="d-flex flex-row me-auto hamburger-menu" >
              <div className="me-0" style={{width:"40px", height:"40px", marginLeft: '-27px'}}>
                { /*<button className={`btn-border ${show? 'd-none' : ''}`} type="button" onClick={menuClick}> 
                  <svg className={`${show ? 'd-none' : ''}`} xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#00000">
                    <path d="M120-120v-80h720v80H120Zm0-320v-80h720v80H120Zm0-320v-80h720v80H120Z"/>
                  </svg>
                </button>
                <button className={`btn-border ${show? '' : 'd-none'}`} type="button" onClick={menuClick}>
                  <svg className={`${show ? '' : 'd-none'}`} xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 0 16 16" width="40px" fill="#00000">
                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                  </svg>
                </button>
                */ }
                <input id="menu__toggle" type="checkbox" ref={inputRef}  style={{display:"none"}} onClick={menuClick} />
                <label class="menu__btn" for="menu__toggle">
                <span style={{marginTop:"23px"}}></span>     
                </label>
              </div>
              <a className=" ms-3" style={{width: "fit-content", height:"fit-content", color:"black", opacity:"80%", textDecoration: "none", marginTop: '2px'}} href="#">
                <img class="colorixlogo" src={icon2} alt="" /></a>
            </div>
            <div className="d-flex flex-row" style={{maxWidth: "fit-content", height: "fit-content", marginTop: '6px'}}>
                <button onClick={() => setShowSearch(prev => !prev)} style={{ background: 'none', border: 'none', color: 'white', textDecoration: 'underline', cursor: 'pointer' }} >
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fffff">
                    <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/>
                  </svg>
                </button>
              <div className="mx-2" style={{width: '2px', height: '19px', backgroundColor: 'black', marginTop: '6px' }}></div>
              <a  href="#" style={{maxWidth: "fit-content"}}>
                <svg xmlns="http://www.w3.org/2000/svg" height="26px" viewBox="0 -960 960 960" width="26px" fill="#fffff">
                  <path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Z"/>
                </svg>
              </a>
              <div className="mx-2 mx-xl-2 mx-xxl-3" style={{width: '2px', height: '19px', backgroundColor: 'black', marginTop: '8px' }}></div>
              <a  href="#" style={{maxWidth: "fit-content"}}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="21px">
                  <path d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"/>
                </svg>
              </a>
              <div className="mx-2 mx-xl-2 mx-xxl-3" style={{width: '2px', height: '19px', backgroundColor: 'black', marginTop: '8px' }}></div>
              <a  href="#" style={{maxWidth: "fit-content"}}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="21px">
                  <path d="M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="gone-layout-xl">
        <div className={`d-flex flex-row ${show ? 'container-width' : 'd-none'} `}>
          <div className={`header-bg-color d-flex flex-column`} style={{height: 'calc(100vh - 60px)', flex: 1}}>
            <div className= {`mb-auto ${smallImpressionClick || smallRestaurantAndHotelClick || smallEventClick || smallGadjetClick || smallYourColorixClick?  'd-none' : 'd-flex flex-column w-100'} `}>
              <div className="row nav-link-hover-sm" role="button" onClick={isSmallImpressionClick} style={{height:'50px'}}>
                <span className="ms-3 col-10 my-auto" style={{textDecoration: 'none', color: 'black', height: 'fit-content'}}>{Navbarcat[0]?.page_part}</span>
                {/*<div style={{height: '6px', borderLeft: '2px solid black', margin: 'auto' }}></div>*/}
                <div className="col-1 position-relative">
                  <svg className="position-absolute top-50 end-0 translate-middle" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                  </svg>
                </div>
              </div>
              <div className="row nav-link-hover-sm" role="button" onClick={isSmallRestaurantAndHotelClick} style={{height:'50px'}}>
                <span className="ms-3 col-10 my-auto" style={{textDecoration: 'none', color: 'black', height: 'fit-content'}}>{Navbarcat[1]?.page_part}</span>
                {/*<div style={{height: '6px', borderLeft: '2px solid black', margin: 'auto' }}></div>*/}
                <div className="col-1 position-relative">
                  <svg className="position-absolute top-50 end-0 translate-middle" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                  </svg>
                </div>
              </div>
              <div className="w-80 row nav-link-hover-sm" role="button" onClick={isSmallEventClick} style={{height:'50px'}}>
                <span className="ms-3 col-10 my-auto" style={{textDecoration: 'none', color: 'black', height: 'fit-content'}}>{Navbarcat[2]?.page_part}</span>
                {/*<div style={{height: '6px', borderLeft: '2px solid black', margin: 'auto' }}></div>*/}
                <div className="col-1 position-relative">
                  <svg className="position-absolute top-50 end-0 translate-middle" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                  </svg>
                </div>
              </div>
              <div className="row nav-link-hover-sm" role="button" onClick={isSmallGadjetClick} style={{height:'50px'}}>
                <span className="ms-3 col-10 my-auto" style={{textDecoration: 'none', color: 'black', height: 'fit-content'}}>{Navbarcat[3]?.page_part}</span>
                {/*<div style={{height: '6px', borderLeft: '2px solid black', margin: 'auto' }}></div>*/}
                <div className="col-1 position-relative">
                  <svg className="position-absolute top-50 end-0 translate-middle" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                  </svg>
                </div>
              </div>
              <div className="row nav-link-hover-sm" role="button" onClick={isSmallYourColorixClick} style={{height:'50px'}}>
                <span className="ms-3 col-10 my-auto" style={{textDecoration: 'none', color: 'black', height: 'fit-content'}}>{Navbarcat[4]?.page_part}</span>
                {/*<div style={{height: '6px', borderLeft: '2px solid black', margin: 'auto' }}></div>*/}
                <div className="col-1 position-relative">
                  <svg className="position-absolute top-50 end-0 translate-middle" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                  </svg>
                </div>
              </div>
            </div>
            {/*submenu for impressions*/}
            <div className= {`mb-auto ${smallImpressionClick? 'd-flex flex-column' : 'd-none' } `} style={{height:'80%'}}>
              <div className="row mb-4" style={{height:'60px', width: '100%'}}>
                <div className="col-1 position-relative" style={{ width: '15%', backgroundColor:'rgba(0, 0, 0, 0.205)'}} role='button' onClick={isSmallImpressionClick}>
                  <svg className="position-absolute top-50 end-0 translate-middle" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                    <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
                  </svg>
                </div>
                <div className="col-9 position-relative ">
                  <span className="position-absolute top-50 start-50 translate-middle" style={{textDecoration: 'none', color: 'black', height: 'fit-content', fontWeight: 'lighter'}}>{Navbarcat[0]?.page_part}</span>
                </div>
              </div>
              <a className="d-flex flex-row justify-content-center mb-4 text-decoration-none" href="#">
                <svg className="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                  <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                </svg>
                <span>{Navbarcat[0]?.page_part}</span>
                <svg className="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                  <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
                </svg>
              </a>
              <div className="d-flex flex-column" style={{overflowY: 'auto', overflowX: 'hidden'}}>
                {navbarcat0.map((val, index) => (
                  <a className="nav-link-hover-sm" href="#">{val}</a>
                ))}
              </div>
            </div>
            {/*submenu for restaurantAndHotel*/}
            <div className= {`mb-auto ${smallRestaurantAndHotelClick? 'd-flex flex-column w-100' : 'd-none' } `} style={{height:'80%'}}>
              <div className="row mb-4" style={{height:'60px', width: '100%'}}>
                <div className="col-1 position-relative" style={{ width: '15%', backgroundColor:'rgba(0, 0, 0, 0.205)'}} role='button' onClick={isSmallRestaurantAndHotelClick}>
                  <svg className="position-absolute top-50 end-0 translate-middle" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                    <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
                  </svg>
                </div>
                <div className="col-9 position-relative ">
                  <span className="position-absolute top-50 start-50 translate-middle" style={{textDecoration: 'none', color: 'black', height: 'fit-content', fontWeight: 'lighter'}}>{Navbarcat[1]?.page_part}</span>
                </div>
              </div>
              <a className="d-flex flex-row justify-content-center mb-4" href="#">
                <svg className="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                  <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                </svg>
                <span>{Navbarcat[1]?.page_part}</span>
                <svg className="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                  <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
                </svg>
              </a>
              <div className="d-flex flex-column" style={{overflowY: 'auto', overflowX: 'hidden'}}>
                {navbarcat1.map((val, index) => (
                  <a className="nav-link-hover-sm" href="#">{val}</a>
                ))}
              </div>
            </div>
            {/*submenu for about us*/}
            <div className= {`mb-auto ${smallEventClick? 'd-flex flex-column' : 'd-none' } `} style={{height:'80%'}}>
              <div className="row mb-4" style={{height:'60px', width: '100%'}}>
                <div className="col-1 position-relative" style={{ width: '15%', backgroundColor:'rgba(0, 0, 0, 0.205)'}} role='button' onClick={isSmallEventClick}>
                  <svg className="position-absolute top-50 end-0 translate-middle" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                    <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
                  </svg>
                </div>
                <div className="col-9 position-relative ">
                  <span className="position-absolute top-50 start-50 translate-middle" style={{textDecoration: 'none', color: 'black', height: 'fit-content', fontWeight: 'lighter'}}>{Navbarcat[2]?.page_part}</span>
                </div>
              </div>
              <a className="d-flex flex-row justify-content-center mb-4 text-decoration-none" href="#">
                <svg className="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                  <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                </svg>
                <span>{Navbarcat[2]?.page_part}</span>
                <svg className="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                  <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
                </svg>
              </a>
              <div className="d-flex flex-column" style={{overflowX: 'hidden'}}>
                {navbarcat2.map((val, index) => (
                  <a className="nav-link-hover-sm" href="#">{val}</a>
                ))}
              </div>
            </div>
            {/*submenu for gadjet*/}
            <div className= {`mb-auto ${smallGadjetClick? 'd-flex flex-column' : 'd-none' } `} style={{height:'80%'}}>
              <div className="row mb-4" style={{height:'60px', width: '100%'}}>
                <div className="col-1 position-relative" style={{ width: '15%', backgroundColor:'rgba(0, 0, 0, 0.205)'}} role='button' onClick={isSmallGadjetClick}>
                  <svg className="position-absolute top-50 end-0 translate-middle" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                    <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
                  </svg>
                </div>
                <div className="col-9 position-relative ">
                  <span className="position-absolute top-50 start-50 translate-middle" style={{textDecoration: 'none', color: 'black', height: 'fit-content', fontWeight: 'lighter'}}>{Navbarcat[3]?.page_part}</span>
                </div>
              </div>
              <a className="d-flex flex-row justify-content-center mb-4 text-decoration-none" href="#">
                <svg className="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                  <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                </svg>
                <span>{Navbarcat[3]?.page_part}</span>
                <svg className="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                  <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
                </svg>
              </a>
              <div className="d-flex flex-column" style={{overflowX: 'hidden'}}>
                {navbarcat3.map((val, index) => (
                  <a className="nav-link-hover-sm" href="#">{val}</a>
                ))}
              </div>
            </div>
            {/*submenu for your colorix*/}
            <div className= {`mb-auto ${smallYourColorixClick? 'd-flex flex-column' : 'd-none' } `} style={{height:'80%'}}>
              <div className="row mb-4" style={{height:'60px', width: '100%'}}>
                <div className="col-1 position-relative" style={{ width: '15%', backgroundColor:'rgba(0, 0, 0, 0.205)'}} role='button' onClick={isSmallYourColorixClick}>
                  <svg className="position-absolute top-50 end-0 translate-middle" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                    <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
                  </svg>
                </div>
                <div className="col-9 position-relative ">
                  <span className="position-absolute top-50 start-50 translate-middle" style={{textDecoration: 'none', color: 'black', height: 'fit-content', fontWeight: 'lighter'}}>{Navbarcat[4]?.page_part}</span>
                </div>
              </div>
              <a className="d-flex flex-row justify-content-center mb-4 text-decoration-none" href="#">
                <svg className="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                  <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                </svg>
                <span>{Navbarcat[4]?.page_part}</span>
                <svg className="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00000">
                  <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
                </svg>
              </a>
              <div className="d-flex flex-column" style={{overflowX: 'hidden'}}>
                {navbarcat4.map((val, index) => (
                  <a className="nav-link-hover-sm" href="#">{val}</a>
                ))}
              </div>
            </div>
          </div>
          <div className="dd-bg-opacity-sm vh-100" onClick={ () => {closeMenus();handleButtonClick();}}></div>
        </div>
      </div>
      {impressionClick && <div className="container-fluid w-100 dropdown-item py-3" style={{zIndex: '999999999', backgroundColor: 'rgb(226, 224, 222)', borderTop:'2px solid  rgba(59, 54, 54, 0.09)'}} ref={impressionElementRef} onMouseEnter={() => {handleImpressionMouseEnter(); stopscrolleffect();}} onMouseLeave={() => {handleImpressionMouseLeave(); enabledpscrolleffect();}} >
        <div className="container-md mt-25 d-flex">
          <div className="w-100 py-2 ps-2 fs-3 fw-semibold">{Navbarcat[0]?.page_part}</div>
          <div className="p-2 flex-shrink-1">
            <svg xmlns="http://www.w3.org/2000/svg" type="button" width="30" height="30" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16" onClick={ () => {isImpressionClick(); enabledpscrolleffect();}}>
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
            </svg>
          </div>
        </div>
        <div className="container-md d-flex flex-cloumn">
          <div className="me-auto my-3 nav grid gap-3">
            {navbarcat0.map((val, index) => (
                  <a className="w-25 nav-link p-auto g-col-6 dd-item-size" href="#">{val}</a>
                ))}
          </div>
          <div className="d-flex flex-column my-3">
            <span className="fw-bold  fs-5 mb-2">Autres</span>
            <a className="mb-2" href="#" role='button' style={{maxWidth:'fit-content', maxHeight:'fit-content'}}>
              <div className="d-flex flex-row">
                <img src={icon8} style={{width:'130px', height:'100px', borderRadius:'5px'}}/> 
                <span className="mb-auto ms-2 fs-5"><small>Nos produits les plus appréciés</small></span>
              </div>
            </a>
            <a className="" href="#" role='button' style={{maxWidth:'fit-content', maxHeight:'fit-content'}}>
              <div className="d-flex flex-row">
                <img src={icon8} style={{width:'130px', height:'100px', borderRadius:'5px'}}/> 
                <span className="mb-auto ms-2 fs-5"><small>Nos produits les plus appréciés</small></span>
              </div>
            </a>
          </div>
        </div>
        <div className="dd-bg-opacity-lg vh-100" onClick={ () => {closeMenus(); enabledpscrolleffect();}}></div>
      </div>}
      {restaurantAndHotelClick && <div className="container-fluid w-100 dropdown-item py-3" style={{zIndex: '999999999', backgroundColor: 'rgb(226, 224, 222)', borderTop:'2px solid  rgba(59, 54, 54, 0.09)'}} ref={restaurantAndHotelElementRef} onMouseEnter={() => {handleRestaurantAndHotelMouseEnter(); stopscrolleffect();}} onMouseLeave={() => {handleRestaurantAndHotelMouseLeave(); enabledpscrolleffect();}} >
        <div className="container-md mt-25 d-flex">
          <div className="w-100 py-2 ps-2 fs-3 fw-semibold">{Navbarcat[1]?.page_part}</div>
          <div className="p-2 flex-shrink-1">
            <svg xmlns="http://www.w3.org/2000/svg" type="button" width="30" height="30" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16" onClick={ () => {isRestaurantAndHotelClick(); enabledpscrolleffect();}}>
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
            </svg>
          </div>
        </div>
        <div className="container-md mx-auto my-3 nav grid gap-3">
          {navbarcat1.map((val, index) => (
                  <a className="w-25 nav-link p-auto g-col-6 dd-item-size" href="#">{val}</a>
                ))}
        </div>
        <div className="dd-bg-opacity-lg vh-100" onClick={ () => {closeMenus(); enabledpscrolleffect();}}></div>
      </div>}
      {eventClick && <div className="container-fluid w-100 dropdown-item py-3" style={{zIndex: '999999999', backgroundColor: 'rgb(226, 224, 222)', borderTop:'2px solid  rgba(59, 54, 54, 0.09)'}} ref={eventElementRef} onMouseEnter={() => {handleEventMouseEnter(); stopscrolleffect();}} onMouseLeave={() => {handleEventMouseLeave(); enabledpscrolleffect();}} >
        <div className="container-md mt-25 d-flex">
          <div className="w-100 py-2 ps-2 fs-3 fw-semibold">{Navbarcat[2]?.page_part}</div>
          <div className="p-2 flex-shrink-1">
            <svg xmlns="http://www.w3.org/2000/svg" type="button" width="30" height="30" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16" onClick={ () => {isEventClick(); enabledpscrolleffect();}}>
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
            </svg>
          </div>
        </div>
        <div className="container-md mx-auto my-3 nav grid gap-3">
          {navbarcat2.map((val, index) => (
                  <a className="w-25 nav-link p-auto g-col-6 dd-item-size" href="#">{val}</a>
                ))}
        </div>
        <div className="dd-bg-opacity-lg vh-100" onClick={ () => {closeMenus(); enabledpscrolleffect();}}></div>
      </div>}
      {gadjetClick && <div className="container-fluid w-100 dropdown-item py-3" style={{zIndex: '999999999', backgroundColor: 'rgb(226, 224, 222)', borderTop:'2px solid  rgba(59, 54, 54, 0.09)'}} ref={gadjetElementRef} onMouseEnter={() => {handlegadjetMouseEnter(); stopscrolleffect();}} onMouseLeave={() => {handlegadjetMouseLeave(); enabledpscrolleffect();}} >
        <div className="container-md mt-25 d-flex">
          <div className="w-100 py-2 ps-2 fs-3 fw-semibold">{Navbarcat[3]?.page_part}</div>
          <div className="p-2 flex-shrink-1">
            <svg xmlns="http://www.w3.org/2000/svg" type="button" width="30" height="30" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16" onClick={ () => {isgadjetClick(); enabledpscrolleffect();}}>
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
            </svg>
          </div>
        </div>
        <div className="container-md mx-auto my-3 nav grid gap-3">
                {navbarcat3.map((val, index) => (
                  <a className="w-25 nav-link p-auto g-col-6 dd-item-size" href="#">{val}</a>
                ))}
           

        </div>
        <div className="dd-bg-opacity-lg vh-100" onClick={ () => {closeMenus(); enabledpscrolleffect();}}></div>
      </div>}
      {yourColorixClick && <div className="container-fluid w-100 dropdown-item py-3" style={{zIndex: '999999999', backgroundColor: 'rgb(226, 224, 222)', borderTop:'2px solid  rgba(59, 54, 54, 0.09)'}} ref={yourColorixElementRef} onMouseEnter={() => {handleYourColorixMouseEnter(); stopscrolleffect();}} onMouseLeave={() => {handleYourColorixMouseLeave(); enabledpscrolleffect();}} >
        <div className="container-md mt-25 d-flex">
          <div className="w-100 py-2 ps-2 fs-3 fw-semibold">{Navbarcat[4]?.page_part}</div>
          <div className="p-2 flex-shrink-1">
            <svg xmlns="http://www.w3.org/2000/svg" type="button" width="30" height="30" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16" onClick={ () => {isYourColorixClick(); enabledpscrolleffect();}}>
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
            </svg>
          </div>
        </div>
        <div className="container-md mx-auto my-3 nav grid gap-3">
            {navbarcat4.map((val, index) => (
                  <a className="w-25 nav-link p-auto g-col-6 dd-item-size" href="#">{val}</a>
                ))}
        </div>
        <div className="dd-bg-opacity-lg vh-100" onClick={ () => {closeMenus(); enabledpscrolleffect();}}></div>
      </div>}
        {/* Search box below navbar */}
        <div className={`search-container ${showSearch ? 'show' : ''}`}>
        <form className="search-form">
         <input
          type="text"
          className="search-input"
          placeholder="Search..."
        />
          <button type="submit" className="search-button"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fffff">
                  <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/>
                </svg></button>
        </form>
      </div>


    </div>
   

    
  );
}

export default HeaderComponent;